import React from 'react';
import clsx from 'clsx';
import 'tslib';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import Spacer from '../../util/Spacer/Spacer.js';
import ProgressBarContainer from '../components/ProgressBar/ProgressBarContainer.js';
import '../../buttons/index.js';
import { getRightLeftFileName, getFileIcon, formatBytes } from '../helper.js';
import './../../../assets/src/components/file-uploadV2/components/ProcessingZone/ProcessingZone.css.ts.vanilla-36b1cf63.css';
import './../../../assets/src/components/file-uploadV2/index.css.ts.vanilla-3089ae81.css';

/* eslint-disable @typescript-eslint/no-explicit-any */
var FileComponent = function (_a) {
    var file = _a.file, hovered = _a.hovered, progressConfig = _a.progressConfig, hasFileProcessing = _a.hasFileProcessing, deleteFile = _a.deleteFile, setProgress = _a.setProgress;
    var _b = getRightLeftFileName(file.name), leftText = _b.leftText, rightText = _b.rightText, fileType = _b.fileType;
    var showCompletedFile = file.processed || (file.uploaded && !file.error && !hasFileProcessing);
    var showProgressBar = !showCompletedFile && !file.error;
    var getRightContent = function () {
        var deleteIconClass = file.isUploading ? 'icon-16-close-mono' : 'icon-16-bin-mono';
        return (React.createElement(React.Fragment, null,
            React.createElement(Visible, { when: !hovered },
                React.createElement(Visible, { when: showCompletedFile },
                    React.createElement("div", { className: 'c-uploader-file__right-info' }, formatBytes(file.size))),
                React.createElement(Visible, { when: file.error },
                    React.createElement("div", { className: 'c-uploader-file__name--incomplete' }, file.error)),
                React.createElement(Visible, { when: showProgressBar },
                    React.createElement("div", { className: 'c-uploader-file__right-info' }, "".concat(progressConfig.progress, "%")))),
            React.createElement(Visible, { when: hovered },
                React.createElement("span", { "data-testid": 'delete-file-icon', className: clsx(deleteIconClass, 'c-uploader-file__icon-blue'), onClick: deleteFile }))));
    };
    var getFileNameContent = function () {
        var fileNameClass = showCompletedFile ? 'c-uploader-file__name--completed' : 'c-uploader-file__name--incomplete';
        var containerClassName = "c-uploader-file__name ".concat(fileNameClass);
        return (React.createElement("div", { className: clsx(containerClassName, hovered && "".concat(fileNameClass, "--hovered")) },
            React.createElement("div", { className: 'c-uploader-file__ellipsis-text' }, leftText),
            rightText));
    };
    return (React.createElement("div", { "data-testid": "uploaded-file-".concat(file.id), className: 'c-uploader-file' },
        React.createElement("div", { className: 'c-uploader-file__left-info-container' },
            React.createElement("div", { className: 'c-uploader-file__left-info' },
                React.createElement("span", { className: clsx(getFileIcon(fileType), 'c-uploader-file__icon-blue'), onClick: deleteFile }),
                React.createElement(Spacer, { right: 14 }),
                React.createElement(Visible, { when: showCompletedFile },
                    React.createElement("span", { className: clsx('icon-checkmark-mono', 'c-uploader-file__icon-blue') }),
                    React.createElement(Spacer, { right: 9 })),
                React.createElement(Visible, { when: file.error },
                    React.createElement("span", { "data-testid": 'info-icon', className: clsx('icon-16-info-mono', 'c-uploader-file__icon-blue') }),
                    React.createElement(Spacer, { right: 9 })),
                getFileNameContent()),
            React.createElement(Visible, { when: showProgressBar },
                React.createElement(Spacer, { top: 4 }),
                React.createElement(ProgressBarContainer, { progressConfig: progressConfig, setProgress: setProgress }))),
        getRightContent()));
};

export { FileComponent as default };
//# sourceMappingURL=FileComponent.js.map
